import { render } from "./SelectedPatientPRN.vue?vue&type=template&id=87128468&scoped=true"
import script from "./SelectedPatientPRN.vue?vue&type=script&lang=js"
export * from "./SelectedPatientPRN.vue?vue&type=script&lang=js"

import "./SelectedPatientPRN.vue?vue&type=style&index=0&id=87128468&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87128468"]])

export default __exports__